import { styled } from "styled-components";

export const FormWrapper = styled.div``;

export const FormHandlerWrapper = styled.div`
  width: 50%;
  padding: 20px;
  @media (max-width: 860px) {
    width: 100%;
  }
`;
